import React from 'react';
import clsx from 'clsx';

import { ArrowLeftOutline } from '../../icons';

export const BackButton = ({ text = '', className, handleBackClick }) => {
  return (
    <button
      type="button"
      className={clsx('flex items-center gap-2', className)}
      onClick={handleBackClick}
    >
      <ArrowLeftOutline /> <h6>{text}</h6>
    </button>
  );
};
